import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const list = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_item`),
  });
};

const update = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_item`),
    params: param,
  });
};
const itemNames = fieldId =>
  list(fieldId).then(response => {
    const itemNames = { A: '', B: '', C: '', D: '' };
    if (!response.result) {
      return itemNames;
    }
    const fieldItemInputs = response.data.entities.field_item;
    itemNames.A = fieldItemInputs.field_item_list1_title;
    itemNames.B = fieldItemInputs.field_item_list2_title;
    itemNames.C = fieldItemInputs.field_item_list3_title;
    itemNames.D = fieldItemInputs.field_item_list4_title;
    return itemNames;
  });

export const FieldItemInputService = {
  list,
  update,
  itemNames,
};

export default FieldItemInputService;



// WEBPACK FOOTER //
// ./src/services/FieldItemInputs.js